import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, shareReplay, switchMap, filter, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoginService } from './login.service';
import { UserSettings } from '../models/usersettings.model';

@Injectable({
  providedIn: 'root',
})
export class CustomAttributesService {
  private apiUrl = environment.portalapiurl;
  private lookupOverrideEnabled$: Observable<boolean> | null = null;

  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) {}

  checkLookupOverrideEnabled(): Observable<boolean> {
    if (!this.lookupOverrideEnabled$) {
      this.lookupOverrideEnabled$ = this.http
        .get<boolean>(`${this.apiUrl}/Designer/LookupOverrideEnabled`)
        .pipe(
          map(response => response === true),
          catchError(() => of(false)),
          shareReplay(1)
        );
    }
    return this.lookupOverrideEnabled$;
  }

  GetCustomAttributesValues(): Observable<any> {
    return this.getAdminUnitId().pipe(
      switchMap(adminUnitId =>
        this.http.get<any>(`${this.apiUrl}/Designer/UserEditableFields`, {
          headers: { 'Content-Type': 'application/json' },
          responseType: 'json',
          params: this.getAdminUnitQueryParams(adminUnitId),
        })
      )
    );
  }

  saveCustomAttributes(fields: Array<{
    fieldId: string;
    fieldName: string;
    value: string;
  }>): Observable<any> {
    return this.getAdminUnitId().pipe(
      switchMap(adminUnitId =>
        this.http.put<any>(`${this.apiUrl}/Designer/UserEditableFields`, fields, {
          headers: { 'Content-Type': 'application/json' },
          responseType: 'json',
          params: this.getAdminUnitQueryParams(adminUnitId),
        })
      )
    );
  }

  private getAdminUnitId(): Observable<string> {
    const settings = this.loginService.portaluser;
    if (settings) {
      return of(this.loginService.resolveAdminUnitId(settings));
    }
    return this.loginService.portaluserLatest.pipe(
      filter((s): s is UserSettings => !!s),
      take(1),
      map(s => this.loginService.resolveAdminUnitId(s))
    );
  }

  private getAdminUnitQueryParams(adminUnitId: string): HttpParams {
    return new HttpParams().set('adminUnitId', adminUnitId);
  }
}
